'use client';

import Link from 'next/link';
import type { Route } from 'next';
import { usePathname } from 'next/navigation';
import { BarChart3, CalendarDays, NotebookPen, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const TABS = [
  { href: '/' as Route, label: 'Schedule', icon: CalendarDays },
  { href: '/notes' as Route, label: 'Notes', icon: NotebookPen },
  { href: '/analytics' as Route, label: 'Stats', icon: BarChart3 },
  { href: '/settings' as Route, label: 'Settings', icon: Settings },
];

export function MobileTabBar() {
  const pathname = usePathname();

  const isActive = (href: string) =>
    href === '/'
      ? pathname === '/' || pathname.startsWith('/section')
      : pathname.startsWith(href);

  return (
    <nav
      aria-label="Primary"
      className="glass fixed inset-x-0 bottom-0 z-40 border-t border-hairline pb-safe lg:hidden"
    >
      <div className="mx-auto grid h-[60px] max-w-md grid-cols-4">
        {TABS.map(({ href, label, icon: Icon }) => {
          const active = isActive(href);
          return (
            <Link
              key={href}
              href={href}
              aria-label={label}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'flex flex-col items-center justify-center gap-1 transition duration-fast ease-out-quint',
                active ? 'text-foreground' : 'text-subtle-foreground',
              )}
            >
              <span
                className={cn(
                  'flex h-7 w-12 items-center justify-center rounded-full transition duration-base ease-out-quint',
                  active && 'bg-accent/15 text-accent',
                )}
              >
                <Icon className="h-[19px] w-[19px]" strokeWidth={active ? 2.1 : 1.8} />
              </span>
              <span className="font-mono text-[9px] uppercase tracking-[0.12em] leading-none">
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
